export default "__VITE_ASSET__JNucWwhT__"